import React from "react";
import { defaultLanguage } from "src/../src-dynamic/destination.languages";
import ErrorBoundary from "src/components/errorboundary/errorboundary.v1";
import Profiler from "src/components/profiler/profiler.v1";
import Module from "src/modules/cta/cta";

const SliceComponent = (props: any) => {
  const { sliceContext } = props;
  return <>
  <Profiler id={`module-cta-${sliceContext.id}`}>
  <ErrorBoundary fallback={null}>
    <Module defaultLanguage={defaultLanguage} data={{ selectedLanguage: sliceContext.language, item: sliceContext.item }} />
  </ErrorBoundary>
  </Profiler>
  </>
}

export default SliceComponent;